// services/productService.js
import axiosInstance from '../axiosConfig'

const API_URL = process.env.REACT_APP_API_URL;

const productService = {
  getProducts: async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}/products`, {withCredentials: true});
      return response.data;
    } catch (error) {
      console.error('Error fetching products', error);
      throw error;
    }
  },

  getProductById: async (id) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching products', error);
      throw error;
    }
  },

  createProduct: async (product) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/products`, product);
      return response.data;
    } catch (error) {
      console.error('Error creating products', error);
      throw error;
    }
  },

  updateProduct: async (id, product) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/products/${id}`, product);
      return response.data;
    } catch (error) {
      console.error('Error updating products', error);
      throw error;
    }
  },

  deleteProduct: async (id) => {
    try {
      const response = await axiosInstance.delete(`${API_URL}/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting products', error);
      throw error;
    }
  },
};

export default productService;
